import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { Router, ActivatedRoute, RouterModule } from "@angular/router";
import { MessageService, ConfirmationService, SelectItem } from "primeng/api";
import { Observable, of } from "rxjs";
import { AbstractFormComponent } from "src/app/admin/common/abstract-edit.component";
import { PARAM_TAGS_PATH } from "src/app/admin/constants/constants";
import { Tags } from "src/app/models/tags";
import { TagsService } from "src/app/services/tags.service";
import { CommonModule } from "@angular/common";
import { InputTextModule } from "primeng/inputtext";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { TooltipModule } from "primeng/tooltip";

@Component({
  standalone: true,
  selector: "app-tags-form",
  templateUrl: "./tags-form.component.html",
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    InputTextModule,
    ButtonModule,
    CardModule,
    ToastModule,
    ConfirmDialogModule,
    TooltipModule,
  ],
})
export class TagsFormComponent
  extends AbstractFormComponent<Tags>
  implements OnInit
{
  pageTitle: string;
  form: FormGroup;
  idField = "id";
  formFields = ["id", "title", "description"];

  service = this.tagsSerive; // Implement the abstract service property

  constructor(
    protected fb: FormBuilder,
    private tagsSerive: TagsService,
    messageService: MessageService,
    confirmationService: ConfirmationService,
    router: Router,
    route: ActivatedRoute,
  ) {
    super(PARAM_TAGS_PATH);
  }

  ngOnInit() {
    this.initializeForm();
    const id = this.route.snapshot.paramMap.get("id");
    if (id) {
      this.pageTitle = "Modifica Tag";
      this.loadItem(+id);
    } else {
      this.pageTitle = "Aggiungi Tag";
    }
  }

  initializeForm() {
    this.form = this.fb.group({
      id: [""],
      title: ["", Validators.required],
      description: [""],
    });
  }

  loadItem(id: number) {
    this.service.getId(id).subscribe(
      (res) => {
        this.form.patchValue({
          title: res.title,
          description: res.description,
          id: res.id,
        });
      },
      (error) => (this.error = error),
    );
  }
}
